import styled from '@emotion/styled'

import { Flex } from 'ui-base/flex/Flex'

export const PageContainer = styled(Flex)`
  width: 100vw;
  height: 100vh;
`
